/**
 * Teatros con textos o comportamientos propios en el frontend.
 *
 * El hash es el identificador que ya viaja en `teatro.hash` y en
 * `configuracion.hash_teatro`. Centralizarlo aquí evita repetir strings
 * mágicos por los componentes y deja en un único sitio la lista de
 * teatros personalizados.
 */
export const TEATRO_HASH_SAN_FERNANDO = 'f8FicByFbTUnVuFL1D6S';

/**
 * Eclectica no muestra la casilla de aceptar comunicaciones: su alta ya las
 * incluye, así que el consentimiento se envía marcado por defecto.
 */
export const TEATRO_HASH_ECLECTICA = '5mWE2j1zaGfV4hSw4KhH';

/**
 * Webs de UCAM Eventos: su home no vende entradas, descarga las que entrega la
 * universidad en el acto de graduación.
 */
export const TEATRO_HASH_UCAM_EVENTOS = 'Nl6TXJcoTlx0AP2Y3DU7'; // ucameventos
export const TEATRO_HASH_UCAM_EVENTOS_CARTAGENA = 'qeMLbhlA14ZwuUkCFcuK'; // ucameventoscartagena

/**
 * Museos Caravaca oculta la etiqueta del check «Entradas otros» en taquilla.
 */
export const TEATRO_HASH_MUSEOS_CARAVACA = 'THg5WSUAZvlA46M8dD6O';

/** Realmurcia Indumentarias vende indumentaria, no inscribe en cantera. */
export const TEATRO_HASH_REALMURCIA_INDUMENTARIAS = 'xcjaysfOYyBZLnf33uRd';

/** AD Ceuta FC rotula el bloque de invitaciones como "soy amig@ abonado". */
export const TEATRO_HASH_ADCEUTAFC = 'tkLkhYegjDOhey7qBROb';

/** Ribadesella CF: el buscador de abonado pide nombre y apellidos, no DNI. */
export const TEATRO_HASH_RIBADESELLA = 'A8LQy9Vzkbl8A6RltGPZ';

/** SD Compostela: reglamento de la Grada de Animación al elegir esa región. */
export const TEATRO_HASH_SDCOMPOSTELA = 'oWNNspqLQhrKdR5CZzAm';

/** SD Ponferradina: rotula el identificador del abonado como "Nº de abonado de temporada". */
export const TEATRO_HASH_SDPONFERRADINA = 'enGBdE8loBhE4yVfdysx';

/** Murcia Promises CF (sitio de la academia del Real Murcia). */
export const TEATRO_HASH_MURCIA_PROMISES = '7ME16Z4zLcQwnTUa9Jzi';

/** BC Badajoz. */
export const TEATRO_HASH_BC_BADAJOZ = 'oKJlTbCtFDANXL6JMNUp';

/** Real Murcia CF. */
export const TEATRO_HASH_REAL_MURCIA = 'J1fKG9AarPuPNJ5hwY0t';

/** Las Noches del Malecón. */
export const TEATRO_HASH_LAS_NOCHES_DEL_MALECON = '7IzXuJcTytAub9imoikD';

/** CE Sabadell FC. */
export const TEATRO_HASH_CE_SABADELL = 'BHlBbABzmZ5qkeNOHcGH';

/** La Mar de Músicas (Cartagena). */
export const TEATRO_HASH_LA_MAR_DE_MUSICAS = 'XcFhuzamdMXbBfNonZkC';

/** Racing Club de Ferrol. */
export const TEATRO_HASH_RACING_FERROL = 'KNID9jzF7nw38XTOOUO6';

/** Reserva de instalaciones: el calendario habla de "reservas", no de entradas. */
export const TEATRO_HASH_RESERVA_INSTALACIONES = 'VaoHOSMXxNr2kdLmCwLv';

/** CD Eldense no usa las acciones LFP del portal AVET (liberar asiento, passwallet). */
export const TEATRO_HASH_CD_ELDENSE = 'PSaG3BjUboDrGdZz6SQq';

/** CB Zaragoza: género y domicilio opcionales, y llama "apoyos" a los patrocinadores. */
export const TEATRO_HASH_CB_ZARAGOZA = '41TJjy7W62k9rSunO6Tt';

/** Copa del Rey de Tenis llama "Entradas" a la tarjeta que el resto rotula "Experiencias". */
export const TEATRO_HASH_COPA_DEL_REY_TENIS = '6j13h323ZPktOB0rRmXz';

/** Leyendas de España descarga el PDF con el texto corto, sin "(Todas las entradas)". */
export const TEATRO_HASH_LEYENDAS_ESPANA = 'eA7S5197umtjMuIECpMX';

/** BM Torrelavega llama "Pista Balonmano" al terreno de juego. */
export const TEATRO_HASH_BM_TORRELAVEGA = 'cP2qNQmYszSuGX8WEnCM';

/** FC Cartagena valida los acompañantes antes de cambiar al modo amigo abonado. */
export const TEATRO_HASH_FC_CARTAGENA = 'I0QtpDfZsTkgWKert1Gp';

/** CD Toledo muestra la función en el detalle de la acreditación. */
export const TEATRO_HASH_CD_TOLEDO = 'QyK2Lux6tM7vnfKINhef';

/** Teatro Liceo renueva sin pasar por el paso del cupón de descuento. */
export const TEATRO_HASH_LICEO = '8h04doWiX1E2m47WLMEP';

/** CF Benidorm Next oculta el texto de venta de entradas y los ítems de cantera y liberar asiento. */
export const TEATRO_HASH_CF_BENIDORM_NEXT = 'WoxQwIhQz0wwbBk0NfYD';

/** CF Benidorm no muestra las casillas legales en la renovación: se aceptan al renovar. */
export const TEATRO_HASH_CF_BENIDORM = 'OzrRUyRl2jMNjATy64i8';

/** Gimnástica Segoviana renueva sin filtrar descuentos por edad. */
export const TEATRO_HASH_GIMNASTICA_SEGOVIANA = 'd1xSKnY4o0QhAx7pwoO9';

/** Sant Antoni oculta "Venta de abonos" cuando el teatro no los muestra y es tipo 2. */
export const TEATRO_HASH_SANT_ANTONI = '1fCcgtXYFcnTxL1S87cf';

/** La cabalgata usa su propio selector de zona en la taquilla. */
export const TEATRO_HASH_CABALGATA = '14wAm2L1Jxx5B3J3xBkH';

/** RBL1912 conserva su propia contraseña para el desbloqueo de anulaciones. */
export const TEATRO_HASH_RBL1912 = 'AHrYE2xhxJjOMLeQA6EK';

/** Xerez CD rotula el bloque de invitaciones como «Comprar». */
export const TEATRO_HASH_XEREZ = 'edH6kpQdmE3SfaQsdVXc';

/**
 * Webs que siguen con el perfil antiguo mientras la sección de "Invitaciones de
 * abonados" del perfil V2 no esté terminada: en el perfil antiguo esa
 * funcionalidad sí funciona. Cuando se cierre en V2, se vacía esta lista.
 */
export const TEATRO_HASH_CP_CACERENO = 'K2CEa3vYJOmQJS1gTuxu';
export const TEATRO_HASH_UCAM_CB = '6nfDGSpJnBAZOAPNff2f';

export const TEATROS_CON_PERFIL_ANTIGUO = [
    TEATRO_HASH_CP_CACERENO,
    TEATRO_HASH_UCAM_CB,
];

/** Las dos webs de UCAM Eventos, que comparten textos y comportamiento. */
export const TEATROS_UCAM_EVENTOS = [
    TEATRO_HASH_UCAM_EVENTOS,
    TEATRO_HASH_UCAM_EVENTOS_CARTAGENA,
];

/**
 * Slug con el que se sufijan las claves de traducción propias de cada
 * teatro (`renovar_abono.renovar_san_fernando`). Se indexa por hash.
 */
export const SLUG_TEATRO_POR_HASH = {
    [TEATRO_HASH_SAN_FERNANDO]: 'san_fernando',
    [TEATRO_HASH_BM_TORRELAVEGA]: 'bmtorrelavega',
    [TEATRO_HASH_LEYENDAS_ESPANA]: 'leyendas',
    [TEATRO_HASH_COPA_DEL_REY_TENIS]: 'copadelreydetenis',
    [TEATRO_HASH_CB_ZARAGOZA]: 'cbzaragoza',
    [TEATRO_HASH_RESERVA_INSTALACIONES]: 'reservainstalaciones',
    [TEATRO_HASH_SDCOMPOSTELA]: 'sdcompostela',
    [TEATRO_HASH_SDPONFERRADINA]: 'sdponferradina',
    [TEATRO_HASH_UCAM_CB]: 'ucamcb',
    [TEATRO_HASH_LA_MAR_DE_MUSICAS]: 'lamardemusicas',
    [TEATRO_HASH_MURCIA_PROMISES]: 'murciapromises',
    [TEATRO_HASH_BC_BADAJOZ]: 'bcbadajoz',
    [TEATRO_HASH_REAL_MURCIA]: 'realmurcia',
    [TEATRO_HASH_CE_SABADELL]: 'cesabadell',
    [TEATRO_HASH_UCAM_EVENTOS]: 'ucameventos',
    [TEATRO_HASH_UCAM_EVENTOS_CARTAGENA]: 'ucameventos',
};